const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCypress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "#4a4a4c",
      fillRule: "evenodd",
      strokeWidth: 1.77778,
      strokeMiterlimit: 10,
      InkscapeStroke: "none"
    },
    d: "M63.11 16c-27.02 0-48.887 21.867-48.887 48.89 0 27.02 21.866 48.887 48.886 48.887 27.023 0 48.891-21.866 48.891-48.886C112 37.868 90.131 16 63.11 16zM46.222 42.133c2.843 0 5.511.355 7.644 1.246 2.313.887 4.446 2.133 6.578 3.91l-4.98 6.754c-1.422-1.066-2.844-1.777-4.086-2.309-1.246-.535-2.844-.71-4.27-.71-6.043 0-9.066 4.62-9.066 14.042 0 4.801.71 8.18 2.312 10.133 1.602 2.133 3.735 3.024 6.754 3.024 1.426 0 2.848-.18 4.09-.711 1.246-.535 2.668-1.246 4.446-2.313l4.976 7.114c-4.086 3.373-8.71 4.976-14.043 4.976-4.266 0-7.824-.89-11.023-2.668-3.02-1.777-5.512-4.441-7.11-7.82-1.6-3.38-2.488-7.29-2.488-11.91 0-4.446.887-8.536 2.488-11.914 1.598-3.555 4.09-6.223 7.11-8.176 3.023-1.602 6.578-2.668 10.668-2.668zm14.933 1.601h12.266l8.535 35.375 9.066-35.375h11.91L89.067 86.398C87.29 91.91 84.621 96 80.891 99.023c-3.735 3.02-8.711 4.622-14.934 5.157L64.711 96c4.09-.535 7.11-1.422 9.066-2.844.711-.535 2.133-2.133 2.133-2.133L61.156 43.734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "#fff",
      fillRule: "evenodd",
      strokeMiterlimit: 10,
      InkscapeStroke: "none"
    },
    d: "M63.11 15.111c-27.5 0-49.776 22.276-49.776 49.78 0 27.498 22.276 49.775 49.775 49.775 27.503 0 49.78-22.276 49.78-49.775 0-27.503-22.278-49.78-49.78-49.78zm0 1.778c26.542 0 48.001 21.458 48.001 48.002 0 26.54-21.458 47.998-48.002 47.998-26.54 0-47.998-21.459-47.998-47.998 0-26.545 21.459-48.002 47.998-48.002z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCypress);
export default __webpack_public_path__ + "static/media/Cypress.c8478567e18f3830294c6f6bcb0d67ac.svg";
export { ForwardRef as ReactComponent };